import React from 'react';
import Styles from '../../../../../stylesheet/css/header-builder/icons/arrow-left.css';
import stylesUndoRedo from '../../../../../stylesheet/css/header-builder/undo-redo.css';

const ArrowLeft = (props) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="13.6px" height="11.7px" viewBox="0 0 13.6 11.7" xmlSpace="preserve" fill="#ffffff">
    <g>
      <g>
        <path className={`st0 ${stylesUndoRedo.svgPath}`} d="M6.1,2.8V0.5c0-0.4-0.4-0.6-0.8-0.4L0.2,3.3c-0.3,0.2-0.3,0.6,0,0.8l5.1,3.2c0.3,0.2,0.8,0,0.8-0.4V4.8 c3.1,0.2,5.5,2.8,5.5,5.9c0,0.6,0.4,1,1,1s1-0.4,1-1C13.6,6.5,10.2,3,6.1,2.8z"/>
      </g>
    </g>
  </svg>
);

export default ArrowLeft;


// WEBPACK FOOTER //
// ./app/header-builder/components/icons/ArrowLeft.js